(function ($) {
    "use strict"; // Start of use strict

    // Add class to navbar when scrolled
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 200) {
            $(".navbar").addClass("scrolled");
        } else {
            $(".navbar").removeClass("scrolled");
        }
    });

  })(jQuery); // End of use strict
